export default __webpack_public_path__ + "static/media/banner1.209d6898.png";